if (typeof klevuSettings === "undefined") {
    var klevuSettings = {};
}

(() => {
    let klevuSettingsMerge = function(target, overrides) {
        switch (true) {
            case typeof target !== typeof overrides:
                return target;

            case Array.isArray(target):
                return target.concat(overrides);

            case typeof target === "object":
                Object.keys(overrides).forEach(function (overrideKey) {
                    switch (true) {
                        case typeof target[overrideKey] === "undefined":
                        case typeof target[overrideKey] !== typeof overrides[overrideKey]:
                        case typeof target[overrideKey] !== "object":
                            target[overrideKey] = overrides[overrideKey];
                            break;

                        default:
                            target[overrideKey] = klevuSettingsMerge(target[overrideKey], overrides[overrideKey]);
                            break;
                    }
                });
                return target;

            default:
                throw new Error("Invalid target or overrides type");
        }
    };

    let defaultKlevuSettings = {
        global: {
            apiKey: "klevu-172724678681417620"
        },
        search: {
            minChars: 0,
            searchBoxSelector: "input[name=q]",
            infiniteScrollOffsetLanding: 700 // Added this property
        },
        url: {
            search: "https://uscs34v2.ksearchnet.com/cs/v2/search",
            landing: "/search"
        },
        powerUp: {}
    };

    let documentClickPreventSelectors = [];
    if (document.querySelector('.modal-overlay')) {
        documentClickPreventSelectors.push('.modal-overlay');
    }
    if (document.querySelector('.modal__toggle-open')) {
        documentClickPreventSelectors.push('.modal__toggle-open');
    }
    if (documentClickPreventSelectors.length > 0) {
        defaultKlevuSettings.search.documentClickPreventSelector = documentClickPreventSelectors.join(',');
    }

    klevuSettings = klevuSettingsMerge(defaultKlevuSettings, klevuSettings);
})();

document.addEventListener('DOMContentLoaded', () => klevu(klevuSettings));
